<template>
  <div class="container">
    <div class="header-btns">
      <div
        class="mwow-button-filled success"
        @click="toRules"
        v-debounce="1000"
      >
        设置审批规则
      </div>
    </div>
    <common-search-form-wrapper :reset="handleReset">
      <el-form size="mini" :model="searchInfo" label-width="70px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="审批单号:" prop="approval_no">
              <el-input
                v-model="searchInfo.approval_no"
                placeholder="请输入审批单号"
                @change="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="学员姓名:" prop="student_id">
              <el-select
                v-model.number="searchInfo.student_id"
                filterable
                clearable
                placeholder="请选择"
                @focus="handleSearchStudent('')"
                :filter-method="handleSearchStudent"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in studentList"
                  :key="item.student_id"
                  :label="item.name"
                  :value="item.student_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务类型:" prop="type">
              <el-select
                v-model="searchInfo.type"
                clearable
                placeholder="请选择"
                @change="handleSearch"
              >
                <el-option label="购买" :value="1"> </el-option>
                <el-option label="退课" :value="2"> </el-option>
                <el-option label="转课" :value="3"> </el-option>
                <el-option label="退单" :value="5"> </el-option>
                <el-option label="退物品" :value="6"> </el-option>
                <el-option label="退服务" :value="7"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="发起人:" prop="initiate_staff_id">
              <common-staff-pull-down
                :defaultSelected.sync="searchInfo.initiate_staff_list"
                :originId.sync="searchInfo.initiate_staff_id"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审批人:" prop="approval_staff_id">
              <common-staff-pull-down
                :defaultSelected.sync="searchInfo.approval_staff_list"
                :originId.sync="searchInfo.approval_staff_id"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="抄送人:" prop="copy_staff_id">
              <common-staff-pull-down
                :defaultSelected.sync="searchInfo.copy_staff_list"
                :originId.sync="searchInfo.copy_staff_id"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="审批状态:" prop="status_arr">
              <el-select
                multiple
                v-model="searchInfo.status_arr"
                @change="handleSearch"
              >
                <el-option label="审批中" :value="1"></el-option>
                <el-option label="已同意" :value="2"></el-option>
                <el-option label="已拒绝" :value="3"></el-option>
                <el-option label="已取消" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发起时间:" prop="create_time">
              <common-date-range-selector
                v-model="searchInfo.create_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleSearch"
                value-format="yyyy-MM-dd"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      class="mwow-table"
      v-horizontal-scroll
      size="mini"
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
      @sort-change="handleSortChange"
      :default-sort="{
        order: 'descending',
        prop: 'create_time',
      }"
    >
      <el-table-column label="审批单号" prop="approval_no">
        <template slot-scope="scope">
          <span
            class="mwow-green"
            style="cursor: pointer"
            @click="toOrderDetail(scope.row)"
            v-debounce="1000"
            >{{ scope.row.approval_no }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="学员姓名" prop="student_name">
        <template slot-scope="scope">
          <span>{{
            scope.row.student_name
              .map((item) => {
                return item;
              })
              .join("、")
          }}</span>
          <span v-if="scope.row.student_name.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column label="业务类型" prop="type">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1">购买</span>
          <span v-if="scope.row.type === 2">退课</span>
          <span v-if="scope.row.type === 3">转课</span>
          <span v-if="scope.row.type === 5">退单</span>
          <span v-if="scope.row.type === 6">退物品</span>
          <span v-if="scope.row.type === 7">退服务</span>
        </template>
      </el-table-column>
      <el-table-column label="发起人" prop="initiate_staff.name">
        <template slot-scope="scope">
          {{
            (scope.row.initiate_staff && scope.row.initiate_staff.name) || "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="发起时间"
        prop="create_time"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      ></el-table-column>
      <el-table-column prop="approval_staff_list">
        <template slot="header">
          审批人
          <el-tooltip effect="dark" placement="top">
            <div slot="content">审批人：所有参与订单审批的人员</div>
            <span
              ><i
                class="el-icon-question"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i
            ></span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span>{{
            scope.row.approval_staff_list
              .map((item) => {
                return item.name;
              })
              .join("、")
          }}</span>
          <span v-if="scope.row.approval_staff_list.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column label="抄送人" prop="copy_staff_list">
        <template slot-scope="scope">
          <span>{{
            scope.row.copy_staff_list
              .map((item) => {
                return item.name;
              })
              .join("、")
          }}</span>
          <span v-if="scope.row.copy_staff_list.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="status">
        <template slot="header">
          审批状态
          <el-tooltip effect="dark" placement="top">
            <div slot="content">审批状态：整个订单最终审批结果</div>
            <span
              ><i
                class="el-icon-question"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i
            ></span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <span class="mwow-red" v-if="scope.row.status === 1">审批中</span>
          <span class="mwow-green" v-if="scope.row.status === 2">已同意</span>
          <span class="mwow-gray" v-if="scope.row.status === 3">已拒绝</span>
          <span class="mwow-yellow" v-if="scope.row.status === 4">已取消</span>
        </template>
      </el-table-column>
      <el-table-column label="审批时间" prop="approval_time"></el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { dateFormat } from "@/utils/timeFormat";
import { searchStudent } from "@/api/globalSearch";
import { PageModule } from "@/store/module/page";
import { approvalListApi } from "@/api/approve";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
    commonSearchFormWrapper,
  },
  props: ["visible"],
  data() {
    return {
      searchInfo: {
        sort_field: "create_time",
        sort_type: "desc",
        status_arr: [],
        create_time: [],
        initiate_staff_id: "",
        initiate_staff_list: [],
        copy_staff_id: "",
        copy_staff_list: [],
        approval_staff_id: "",
        approval_staff_list: [],
      },
      studentList: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
    };
  },
  mounted() {
    if (
      PageModule.latestRoute === "approveRule" ||
      PageModule.latestRoute === "approveLogDetail"
    ) {
      // 内页返回
      const pageCache = PageModule.pageInfo.approveLogAll;
      if (pageCache.search_info) {
        this.searchInfo = pageCache.search_info;
      }
      if (pageCache.page) {
        this.page = pageCache.page;
      }
      if (pageCache.page_size) {
        this.pageSize = pageCache.page_size;
      }
    } else if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      if (this.$route.params.status_arr) {
        this.searchInfo.status_arr = JSON.parse(this.$route.params.status_arr);
      }
    }
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.handleSearch();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.handleSearch();
    }
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleReset() {
      this.searchInfo = {
        sort_field: "create_time",
        sort_type: "desc",
        status_arr: [],
        create_time: [],
        initiate_staff_id: "",
        initiate_staff_list: [],
        copy_staff_id: "",
        copy_staff_list: [],
        approval_staff_id: "",
        approval_staff_list: [],
      };
      this.handleSearch();
    },
    handleSortChange(e) {
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.handleSearch();
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 50,
        key_word: v || "",
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        sort_field: "create_time",
        sort_type: this.searchInfo.sort_type,
      };
      if (this.searchInfo.approval_no) {
        option.approval_no = this.searchInfo.approval_no;
      }
      if (this.searchInfo.student_id) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.type) {
        option.type = this.searchInfo.type;
      }
      if (this.searchInfo.initiate_staff_id) {
        option.initiate_staff_id = this.searchInfo.initiate_staff_id;
      }
      if (this.searchInfo.approval_staff_id) {
        option.approval_staff_id = this.searchInfo.approval_staff_id;
      }
      if (this.searchInfo.copy_staff_id) {
        option.copy_staff_id = this.searchInfo.copy_staff_id;
      }
      if (
        this.searchInfo.status_arr &&
        this.searchInfo.status_arr.length >= 0
      ) {
        option.status_arr = this.searchInfo.status_arr;
      }
      if (
        this.searchInfo.create_time &&
        this.searchInfo.create_time.length >= 0
      ) {
        option.start_date = this.searchInfo.create_time[0];
        option.end_date = this.searchInfo.create_time[1];
      }
      approvalListApi(option).then((res) => {
        this.page = res.data.page;
        this.total = res.data.total;
        res.data.list.map((item) => {
          item.create_time =
            item.create_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.create_time * 1000);
          item.approval_time =
            item.approval_time === 0
              ? "-"
              : dateFormat("YYYY-mm-dd HH:MM", item.approval_time * 1000);
          // 只有有转入学员并且两个学员不同,不是自己转自己
          if (
            item.transfer_join_student !== null &&
            item.student.student_id !== item.transfer_join_student.student_id
          ) {
            item.student_name = [
              item.student.name,
              item.transfer_join_student.name,
            ];
          } else {
            item.student_name = [item.student.name];
          }
        });
        this.tableData = res.data.list;
      });
    },
    handlePagerChange(e) {
      this.cachePageInfo();
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.cachePageInfo();
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "approveLogAll",
        key: "search_info",
        value: { ...this.searchInfo },
      });
      PageModule.SET_PAGE_INFO({
        name: "approveLogAll",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "approveLogAll",
        key: "page_size",
        value: this.pageSize,
      });
    },
    toRules() {
      this.cachePageInfo();
      this.$router.push({
        name: "approveRule",
      });
    },
    toOrderDetail(data) {
      this.cachePageInfo();
      this.$router.push({
        name: "approveLogDetail",
        query: {
          id: String(data.approval_id),
          from: "all",
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.header-btns {
  margin-bottom: 12px;
}
</style>
